import React from "react";
import styled from "styled-components";
import { useIntl } from "react-intl";
import { smtpWizardMessages } from "../messages";

type SummaryProps = {
  server: string;
  port: string;
  useTls: string;
  username: string;
  sender: string;
  recipients: string[];
};

export const Summary = ({ server, port, useTls, username, sender, recipients }: SummaryProps) => {
  const intl = useIntl();

  return (
    <>
      <ListWrapper>
        <Text>
          <b>{intl.formatMessage(smtpWizardMessages.mailServer)}:</b> {server}
        </Text>
        <Text>
          <b>{intl.formatMessage(smtpWizardMessages.mailPort)}:</b> {port}
        </Text>
        <Text>
          <b>{intl.formatMessage(smtpWizardMessages.useTLS)}:</b>{" "}
          {useTls
            ? intl.formatMessage(smtpWizardMessages.onTLS)
            : intl.formatMessage(smtpWizardMessages.offTLS)}
        </Text>
        {username && (
          <Text>
            <b>{intl.formatMessage(smtpWizardMessages.username)}:</b> {username}
          </Text>
        )}
        <Text>
          <b>{intl.formatMessage(smtpWizardMessages.mailSender)}:</b> {sender}
        </Text>
        <Text>
          <b>{intl.formatMessage(smtpWizardMessages.mailRecipients)}:</b> {recipients?.join(", ")}
        </Text>
      </ListWrapper>
    </>
  );
};

const Text = styled.p`
  margin: 0;
`;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 15px;
`;
